import { doGetRequest } from "./ApiService";
import { baseHeaders } from "./Headers";

export function getCart(): Promise<any> {
  const url = `/cart?type=JOIN&status=OPENED&gw-app-key=${process.env.VUE_APP_X_GW_APP_KEY}`;
  const headers = {
    ...baseHeaders,
    "x-uid": process.env.VUE_APP_X_UID,
    "x-customer-id": localStorage.getItem("x-customer-id")!,
    authorization: "Bearer ".concat(localStorage.getItem("x-access-token")!),
  };
  return doGetRequest(url, headers);
}
